// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5E6g6","content":"styles_content__26t-Z","row":"styles_row__2dla_","footer":"styles_footer__2xmnJ","phraseLength":"styles_phraseLength___mnTA"};